import { twMerge } from '@/lib/classname/twMerge'
import { Card } from '@/ui/cards/card/Card'
import { QrCode } from '@/ui/qr-code/QrCode.client'

const QR_CODE_SIZE = 156

export type ProductBarCodeProps = UiComponentProps<{
  url: string
  reference: string
  label: string
  qrCodeTitle: string
}>

export function ProductBarCode({
  url,
  reference,
  label,
  qrCodeTitle,
  className,
  id,
  'data-testid': dataTestId = 'product-bar-code',
}: ProductBarCodeProps) {
  return (
    <Card
      id={id}
      data-testid={dataTestId}
      padding="lg"
      radius="sm"
      skin="body-alt"
      className={twMerge(className, 'flex flex-col items-center gap-2')}
    >
      <div className="flex max-w-25 flex-col items-center gap-1 rounded-sm border-px border-dashed border-brand-2-200 bg-white p-3 hd:border-1.5">
        <QrCode
          url={url}
          title={qrCodeTitle}
          size={QR_CODE_SIZE}
          data-testid={`${dataTestId}/qr-code`}
        />
        <span className="text-lg font-bold leading-light" data-testid={`${dataTestId}/reference`}>
          {reference}
        </span>
      </div>
      <span className="text-xl font-bold leading-light" data-testid={`${dataTestId}/label`}>
        {label}
      </span>
    </Card>
  )
}
